export default {
  user: {
    default: 'Utilisateur | Utilisateurs',
    list: {
      page_title: 'Liste des utilisateurs'
    },
    add: {
      default: "Ajout d'un utilisateur"
    },
    edit: {
      default: "Edition d'un utilisateur",
      page_title: 'Modification de l\'utilisateur :'
    },
    show: {
      page_title: 'Fiche utilisateur',
      tab_title: {
      },
      travel_policy_mode: {
        0: '@:travelPolicy.mode.0',
        10: '@:travelPolicy.mode.10',
        20: '@:travelPolicy.mode.20',
        30: '@:travelPolicy.mode.30'
      }
    },
    onlinePolicy: {
      excludeNonFree: '@:company.excludeOnlineNonFreeCancellation',
      maxPrice: '@:booking.maxPricePerRoom',
      overrideExcludeNonFree: 'Outrepasser la valeur définie pour la société',
      overrideMaxPrice: 'Outrepasser le montant défini pour la société'
    },
    my_profil: 'Votre profil',
    position: 'Fonction',
    role: 'Rôle',
    role_user: 'Utilisateur',
    role_manager: 'Manager',
    per_text: 'Par prénom, nom, email',
    profile_show: 'Voir mon profil'
  },
  create_account: {
    success: {
      define_password: "Afin de définir votre mot de passe, un email vient d'être envoyé à {email}. Vous pourrez ensuite vous authentifier et effectuer votre réservation",
      info: 'Votre demande de création de compte a été transmise à BBA et va être traitée dans les plus brefs délais.'
    },
    phone_placeholder: 'Un n° de tel requis',
    intro: {
      i1: "Bienvenue sur l'espace réservation dédié à {company}.",
      i2: "Pour bénéficier des services de réservation d'hôtel BBA, suivez les étapes :",
      1: '1- Complétez et envoyez le formulaire ci-dessous.',
      2: '2- Créez votre mot de passe. Un lien vient de vous être envoyé par email pour effectuer ce paramétrage (pensez à vérifier vos spams).',
      3: '3- Connectez-vous sur <a href="https://resa.groupebba-bma.com/">https://resa.groupebba-bma.com/</a> avec vos identifiants personnels. Votre login est l’email renseigné à l’étape 1 et le mot de passe celui créé à l’étape 2.',
      4: '4- Réservez votre séjour !'
    }
  },
  define_password: {
    phrase: 'Redéfinition du mot de passe de',
    current_password: 'Mot de passe actuel',
    new_password: 'Nouveau mot de passe',
    confirm_new_password: 'Confirmer nouveau mot de passe',
    alert: {
      success: 'Votre mot de passe a été réinitialisé'
    },
    invalid_token: 'Ce lien a expiré, veuillez renouveler votre demande de réinitialisation de mot de passe.',
    redirect_login: 'Retour à la page d\'accueil'
  },
  change_company_logo: {
    alert: {
      success: 'Le logo a été modifié avec succès'
    }
  }
}
